import { classNames } from '@boschebike/ebds-js';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import React, { useId, useRef } from 'react';
const InteractiveList = ({
  ref = null,
  items = [],
  standout = false,
  gap = '0.5rem',
  itemHeight = '88px',
  itemPadding = '1.5rem',
  iconColor = 'var(--color-base-primary)',
  iconSize = '24px',
  iconName = 'forwardright',
  separator = true,
  separatorColor = '#C3C6CC'
}) => {
  const componentId = useId();
  const componentRef = useRef(ref);
  const mainClassUuid = `ebds-interactive-list-${componentId}`;
  const mainClass = classNames('ebds-interactive-list', {
    '--standout': standout
  });
  const itemStyle = {
    backgroundColor: standout ? 'var(--ebds-color-background-primary)' : 'var(--bosch-gray-95)',
    height: itemHeight,
    padding: itemPadding
  };
  return /*#__PURE__*/React.createElement("div", {
    id: mainClassUuid,
    ref: componentRef,
    className: mainClass,
    style: {
      gap,
      '--ebds-interactive-list-icon-color': iconColor,
      '--ebds-interactive-list-icon-size': iconSize,
      '--ebds-interactive-list-separator-color': separatorColor
    }
  }, items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "ebds-interactive-list__item-container"
  }, /*#__PURE__*/React.createElement("a", {
    key: index,
    className: "ebds-interactive-list__item",
    href: item.url,
    target: item.target ? item.target : '_self',
    rel: item.rel ? item.rel : '',
    style: itemStyle
  }, item.element, /*#__PURE__*/React.createElement(IconAsChunk, {
    iconName: item.iconName || iconName
  })), separator ? /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "ebds-interactive-list__separator"
  }) : null)));
};
export default InteractiveList;